var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"pop",staticClass:"tippop",style:({display: _vm.isshow})},[_c('div',{staticClass:"tippopbox"},[_c('h2',[_vm._v("恭喜你，已是我馆志愿者")]),_vm._v(" "),_c('span',{on:{"click":function($event){$event.stopPropagation();return _vm.confirm($event)}}},[_vm._v("完成")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-691e4179","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/tipcommon.vue
// module id = null
// module chunks = 